import type { SearchResponseFields } from '../types';
import { isEmpty, isNil, omit } from 'ramda';

// Drops the semantic search text, which is free text typed by the user
const withoutSemanticQuery = (filters: Record<string, any>): Record<string, any> => {
  if (typeof filters.misc !== 'object' || !filters.misc || !('semanticQuery' in filters.misc)) {
    return filters;
  }

  const misc = omit(['semanticQuery'], filters.misc);
  return isEmpty(misc) ? omit(['misc'], filters) : { ...filters, misc };
};

export const buildAnalyticsActiveFilters = (
  rawFilters: Record<string, any> | null | undefined,
  fields: SearchResponseFields | null,
): Record<string, any> => {
  const searchResponseFilters = isNil(rawFilters) || isEmpty(rawFilters) ? undefined : rawFilters;
  let searchActiveFilters: Record<string, any> = withoutSemanticQuery({ ...searchResponseFilters });

  if (
    searchActiveFilters.priceSection &&
    !searchActiveFilters.priceSection.weddingBudget &&
    !searchActiveFilters.priceSection.venueHirePrice
  ) {
    const priceBracket = Object.keys(searchActiveFilters.priceSection);
    searchActiveFilters = { ...searchActiveFilters, priceSection: { priceBracket } };
  }

  const { radiusIncrease, capacityDining, accommodationRooms } = fields ?? {};
  if (radiusIncrease || capacityDining || accommodationRooms) {
    searchActiveFilters = {
      ...searchActiveFilters,
      misc: { ...searchActiveFilters.misc, radiusIncrease, capacityDining, accommodationRooms },
    };
  }

  if (fields?.hasLateAvailability) {
    searchActiveFilters = {
      ...searchActiveFilters,
      specialOffers: {
        ...searchActiveFilters.specialOffers,
        hasLateAvailability: fields.hasLateAvailability,
      },
    };
  }

  return searchActiveFilters;
};
